import React from "react";
import { Link } from "react-router-dom";
import { LegalLayout } from "../components/LegalLayout";
import {
  APP_NAME, SUPPORT_EMAIL, LEGAL_ROUTES,
} from "../lib/legal";

function Section({ title, children }) {
  return (
    <section style={{ marginTop: 26 }}>
      <h2 style={{
        margin: "0 0 10px",
        fontSize: 20,
        fontWeight: 700,
        color: "var(--mf-text)",
        letterSpacing: -0.2,
      }}>
        {title}
      </h2>
      {children}
    </section>
  );
}

function P({ children }) {
  return <p style={{ margin: "0 0 12px" }}>{children}</p>;
}

function UL({ children }) {
  return <ul style={{ margin: "0 0 12px", paddingLeft: 22 }}>{children}</ul>;
}

// Public general terms — content strictly aligned with the real audit.
// No abusive limitation of liability, no free-form invention.
export default function Terms() {
  return (
    <LegalLayout
      title="Conditions générales d'utilisation"
      description={`Règles d'utilisation de ${APP_NAME}.`}
      pathname={LEGAL_ROUTES.terms}
    >
      <P>
        Les présentes conditions décrivent les règles d&apos;utilisation de{" "}
        {APP_NAME}. En créant un compte et en utilisant le service, vous les acceptez.
      </P>

      <Section title="1. Objet du service">
        <P>
          {APP_NAME} est un outil d&apos;organisation et de suivi personnel pour vos
          véhicules et leurs documents. Il vous permet notamment de suivre les
          échéances d&apos;entretien et de documents, de recevoir des rappels, de
          consulter vos interventions et de partager volontairement certains
          documents par un lien.
        </P>
      </Section>

      <Section title="2. Création et sécurité du compte">
        <UL>
          <li>Vous pouvez créer un compte avec une adresse email valide ou via la connexion Google.</li>
          <li>Vous êtes responsable de la sécurité de votre mot de passe et de votre session.</li>
          <li>Vous vous engagez à fournir des informations exactes et à les maintenir à jour.</li>
        </UL>
      </Section>

      <Section title="3. Utilisation autorisée">
        <UL>
          <li>{APP_NAME} est destiné à un usage personnel ou professionnel pour la gestion de vos propres véhicules.</li>
          <li>Vous vous engagez à respecter les lois applicables lors de l&apos;utilisation du service.</li>
          <li>Vous restez seul·e responsable des contenus que vous ajoutez.</li>
        </UL>
      </Section>

      <Section title="4. Contenus, documents et exactitude">
        <UL>
          <li>Les informations que vous saisissez restent sous votre responsabilité.</li>
          <li>Vous garantissez avoir le droit de téléverser les documents et images que vous ajoutez.</li>
          <li>{APP_NAME} ne vérifie pas la validité juridique ou administrative des documents que vous stockez.</li>
        </UL>
      </Section>

      <Section title="5. Partages publics">
        <P>
          Si vous décidez de créer un lien de partage, vous acceptez que toute
          personne disposant du lien puisse accéder aux documents que vous avez
          sélectionnés, sans mot de passe. Il vous appartient de ne transmettre le
          lien qu&apos;aux personnes autorisées. Vous pouvez révoquer un lien à tout
          moment.
        </P>
      </Section>

      <Section title={`6. Positionnement du service — ce que ${APP_NAME} n'est pas`}>
        <P>
          {APP_NAME} est un outil d&apos;organisation et de suivi. Il ne remplace en
          aucun cas :
        </P>
        <UL>
          <li>un mécanicien ou un professionnel de l&apos;automobile ;</li>
          <li>un centre de contrôle technique ;</li>
          <li>votre assureur ;</li>
          <li>une administration ;</li>
          <li>un avocat ;</li>
          <li>un conseiller financier ;</li>
          <li>les obligations légales du propriétaire ou de l&apos;exploitant du véhicule.</li>
        </UL>
        <P>
          Les rappels et notifications ne constituent pas une garantie. Il vous
          appartient de vérifier les dates, les kilométrages, les résultats du scan
          de facture, et de conserver les documents originaux importants. Vous devez
          accomplir les démarches obligatoires (contrôle technique, assurance,
          entretiens critiques…) indépendamment de l&apos;application.
        </P>
      </Section>

      <Section title="7. Alertes, notifications et scan de facture">
        <UL>
          <li>Les notifications peuvent être retardées, non délivrées ou manquées selon votre navigateur, votre système d&apos;exploitation et votre configuration.</li>
          <li>Aucune garantie de délai de réception ni de disponibilité ininterrompue des notifications n&apos;est fournie.</li>
          <li>Le résultat du scan de facture est indicatif : il peut contenir des erreurs et doit toujours être vérifié avant validation.</li>
        </UL>
      </Section>

      <Section title="8. Disponibilité du service">
        <P>
          {APP_NAME} est fourni en l&apos;état, dans la limite des moyens raisonnables
          de son éditeur. Des interruptions techniques, opérations de maintenance ou
          évolutions peuvent survenir. Elles ne sauraient engager la responsabilité
          de l&apos;éditeur au-delà de ce que prévoit la loi.
        </P>
      </Section>

      <Section title="9. Propriété intellectuelle">
        <UL>
          <li>{APP_NAME}, ses éléments graphiques, son code et sa marque appartiennent à son éditeur.</li>
          <li>Les contenus que vous ajoutez restent votre propriété. En les téléversant, vous nous accordez uniquement le droit strictement nécessaire à l&apos;affichage et au stockage dans le cadre du service.</li>
        </UL>
      </Section>

      <Section title="10. Contenus et comportements interdits">
        <UL>
          <li>Ajouter des contenus illégaux ou portant atteinte aux droits d&apos;un tiers.</li>
          <li>Téléverser des fichiers malveillants.</li>
          <li>Tenter d&apos;accéder aux données d&apos;un autre utilisateur.</li>
          <li>Contourner les mesures de sécurité de l&apos;application.</li>
          <li>Utiliser l&apos;application à des fins de fraude.</li>
          <li>Partager des données sans autorisation.</li>
          <li>Surcharger volontairement le service.</li>
        </UL>
      </Section>

      <Section title="11. Suspension et fermeture d'un compte">
        <P>
          En cas de manquement grave aux présentes conditions, l&apos;éditeur peut
          suspendre ou fermer un compte, si nécessaire sans préavis, dans le respect
          de la loi.
        </P>
      </Section>

      <Section title="12. Suppression volontaire du compte">
        <P>
          Vous pouvez à tout moment supprimer votre compte et l&apos;ensemble de vos
          données depuis votre profil. La procédure et les données concernées sont
          décrites sur la page <Link to={LEGAL_ROUTES.deleteAccount}>Suppression de compte</Link>.
        </P>
      </Section>

      <Section title="13. Modification du service et des conditions">
        <P>
          Le service et ces conditions peuvent évoluer. Les modifications
          significatives seront communiquées dans un délai raisonnable. La date de
          dernière mise à jour figure en haut de la page.
        </P>
      </Section>

      <Section title="14. Droit applicable et litiges">
        <P>
          Les présentes conditions sont régies par le droit français, sous
          réserve des dispositions impératives protectrices applicables aux
          consommateurs. En cas de difficulté, vous êtes invité·e à contacter
          préalablement <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>{" "}
          afin de rechercher une solution amiable. À défaut, le litige relève
          des juridictions compétentes conformément aux règles légales
          applicables.
        </P>
        <P>
          {APP_NAME} étant à ce jour une application gratuite éditée à titre
          non professionnel, aucun médiateur de la consommation n&apos;a été
          désigné. Ce point sera revu si une offre commerciale payante est
          proposée à l&apos;avenir.
        </P>
      </Section>

      <Section title="15. Contact">
        <P>
          Pour toute question relative aux présentes conditions, écrivez à{" "}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
        </P>
      </Section>
    </LegalLayout>
  );
}
